import { decode } from "he";
import { useRef } from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import { SideBarLinkButton } from "./SideBarLinkButton";
import type { NavigationItem } from "./types";

import styles from "../Menu.module.css";

export const SideBarContextLink = ({
  isMinimized,
  navigationItem,
  renderMenu,
}: {
  isMinimized: boolean;
  navigationItem: NavigationItem;
  renderMenu: (items: Array<NavigationItem>) => JSX.Element[];
}) => {
  const overlayRef = useRef<OverlayPanel>(null);
  return (
    <>
      <SideBarLinkButton
        dataCy={navigationItem.dataCy}
        key={`nav_link_${navigationItem.id}`}
        text={decode(navigationItem.text ?? "")}
        hideText={isMinimized}
        icon={navigationItem.icon ?? ""}
        fillColor={navigationItem.fillColor}
        showTooltip={navigationItem.showTooltip && isMinimized}
        truncateText={navigationItem.truncateText}
        onClick={(e) => overlayRef.current?.toggle(e)}
      />
      <OverlayPanel
        ref={overlayRef}
        className={styles.popupMenuOverlay}
        pt={{ content: { className: styles.contentPopupMenuOverlay } }}
        data-cy={`overlay-${navigationItem.dataCy}`}
      >
        {renderMenu(navigationItem.submenuItems ?? [])}
      </OverlayPanel>
    </>
  );
};
